import * as React from "react";
import Badge, { BadgeProps } from "@mui/material/Badge";

// interface Props extends BadgeProps{
//     badgeContent?:React.ReactNode;
// }

const FdBadge = ({
  badgeContent,
  children,
  ...rest
}: BadgeProps): JSX.Element => {
  return (
    <Badge badgeContent={badgeContent} {...rest}>
      {children}
    </Badge>
  );
};
export default FdBadge;
